<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('AddSupplier')"
      :active.sync="isSidebarActiveLocal"
      @close="closeSupplierPopup"
      @cancel="closeSupplierPopup"
    >
      <div style="min-height: 400px">
        <b-row>
          <b-col>
            <vs-card>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierName')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierName"
                    type="text"
                    class="w-full"
                    name="supplierName"
                    v-validate="'required'"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('supplierName')">{{
                    errors.first("supplierName")
                  }}</span>
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierCode')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierCode"
                    type="text"
                    class="w-full"
                    name="supplierCode"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('supplierCode')">{{
                    errors.first("supplierCode")
                  }}</span>
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierPhone')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierPhone"
                    type="text"
                    class="w-full"
                    name="supplierPhone"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('supplierPhone')"
                    >{{ errors.first("supplierPhone") }}</span
                  >
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierRepresentative')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierRepresentative"
                    type="text"
                    class="w-full"
                    name="supplierRepresentative"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('supplierRepresentative')"
                    >{{ errors.first("supplierRepresentative") }}</span
                  >
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierAddress')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierAddress"
                    type="text"
                    class="w-full"
                    name="supplierAddress"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('supplierAddress')"
                    >{{ errors.first("supplierAddress") }}</span
                  >
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('SupplierDescription')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="supplierDescription"
                    type="text"
                    class="w-full"
                    name="supplierDescription"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('supplierDescription')"
                    >{{ errors.first("supplierDescription") }}</span
                  >
                </b-col>
              </b-row>
            </vs-card>
          </b-col>
        </b-row>
        <div class="items-center pl-6 mt-0 mb-0">
          <b-row align-h="end">
            <b-col cols="3" md="auto" style="padding: 0px">
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="closeSupplierPopup"
              >
                <Icon
                  icon="material-symbols:cancel-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Cancel") }}
              </b-button>
            </b-col>
            <b-col cols="3" md="auto">
              <b-button
                class="bg-primary"
                style="border-color: white"
                v-on:click="submitData()"
              >
                <Icon
                  icon="material-symbols:save-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Save") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
export default {
  components: { Icon, vSelect, AgGridVue },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => [{}],
    },
  },
  data() {
    return {
      ROLE: this.$store.state.AppActiveUser.ROLE,

      supplierId: "",
      supplierName: "",
      supplierPhone: "",
      supplierAddress: "",
      supplierRepresentative: "",
      supplierDescription: "",
      supplierCode: "",
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
    };
  },
  methods: {
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addCustomerSupplier";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            supplierId: createdId,
            supplierName: this.supplierName,
            supplierPhone: this.supplierPhone,
            supplierAddress: this.supplierAddress,
            supplierRepresentative: this.supplierRepresentative,
            supplierDescription: this.supplierDescription,
            supplierCode: this.supplierCode,
          };
          if (this.data.length) {
            method = "updateCustomerSupplier";
            obj = {
              supplierId: this.supplierId,
              supplierName: this.supplierName,
              supplierPhone: this.supplierPhone,
              supplierAddress: this.supplierAddress,
              supplierRepresentative: this.supplierRepresentative,
              supplierDescription: this.supplierDescription,
              supplierCode: this.supplierCode,
            };
          }
          this.$store
            .dispatch("customer/" + method, obj)
            .then((response) => {
              try {
                if (response.data.success == true) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.closeSupplierPopup();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              } catch (error) {
                console.log(error);
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },

    closeSupplierPopup() {
      this.isSidebarActiveLocal = false;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },

  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    data(val) {
      console.log(val);
      this.supplierId = val.SupplierId;
      this.supplierName = val.SupplierName;
      this.supplierPhone = val.SupplierPhone;
      this.supplierAddress = val.SupplierAddress;
      this.supplierRepresentative = val.SupplierRepresentative;
      this.supplierDescription = val.SupplierDescription;
      this.supplierCode = val.SupplierCode;

      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        const dict = {
          custom: {
            customer: {
              required: this.$t("customerNameRequired"),
              alpha: this.$t("customerNameRequired"),
            },

            brand: {
              required: this.$t("brandRequired"),
              alpha: this.$t("brandRequired"),
            },
          },
        };
        Validator.localize("en", dict);
      }
      return val;
    },
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
